<template>
  <div
    :class="['sidebar-overlay', { visible: isOpen }]"
    @click.self="closeSidebar"
  >
    <aside class="sidebar">
      <!-- Logo -->
      <header class="sidebar-header">
        <img
          src="@/assets/logos/agroairbarra.png"
          alt="Logo AgroAir"
          class="sidebar-logo"
        />
      </header>

      <!-- Navegación -->
      <nav>
        <ul>
          <li @click="navigateTo(5)">Producción diaria</li>
          <li @click="navigateTo(7)">Producción semanal</li>
          <li @click="navigateTo(8)">Producción de la campaña</li>
          <li @click="navigateTo(9)">Control de producción</li>
          <!-- Botón de cerrar sesión (solo texto) -->
          <li class="logout-btn" @click="logout">Cerrar sesión</li>
        </ul>
      </nav>

      <!-- Botón cerrar -->
      <footer class="sidebar-footer">
        <button class="sidebar-close-btn" @click="closeSidebar">
          <img :src="closeIcon" alt="Cerrar" class="sidebar-close-icon" />
        </button>
      </footer>

      <!-- WhatsApp flotante -->
      <div class="whatsapp-float">
        <a href="https://wa.me/644010320" target="_blank" rel="noopener">
          <img
            src="@/assets/icon/whatsapp.png"
            alt="WhatsApp"
            class="whatsapp-icon"
          />
        </a>
      </div>
    </aside>
  </div>
</template>

<script>
import closeIcon from "@/assets/icon/close.png";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      closeIcon,
    };
  },

  methods: {
    closeSidebar() {
      this.$emit("close");
      this.$root.$emit("sidebar-closed");
    },
    navigateTo(tabIndex) {
      this.$emit("navigate", tabIndex);
      this.closeSidebar();
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      this.$router.push("/");
      this.closeSidebar();
    },
  },
};
</script>
